import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { SeismicClaimTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';


@Component({
  selector: 'cradua-seismic-claim-type-container',
  templateUrl: './seismic-claim-type-container.component.html',
  styleUrls: ['./seismic-claim-type-container.component.scss']
})
export class SeismicClaimTypeContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  seismicclaimtypes$: Observable<SeismicClaimTypeDto[]>;
  loading: boolean;
  isLoadingSeismicClaimType$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingSeismicClaimType$ = this.gatwayFacade.isLoadingGateway("SeismicClaimType");
    this.seismicclaimtypes$ = this.gatwayFacade.loadGateway("SeismicClaimType");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSeismicClaimType(deletedValue: any) {
    this.gatwayFacade.remove("SeismicClaimType", deletedValue);
  }


// this method control both the create and update

  onSubmitSeismicClaimType(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.SeismicClaimTypes;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllSeismicClaimType = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllSeismicClaimType.push(pullData[i]);
    }
  }

// check if the addAllSeismicClaimType array is not empty, then dispatch the data to the store
   if(addAllSeismicClaimType.length > 0) {
    this.gatwayFacade.add('SeismicClaimType', addAllSeismicClaimType);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('SeismicClaimType', allUpdates, ['id']);
  }

   }


}
